// Lazy libsodium loader for the NC1 (libsodium) E2EE modules.
//
// Dynamic import() keeps the ~1MB sodium bundle out of the initial chunk —
// same pattern E2EEHelper uses for e3kit. vite.config.js aliases
// 'libsodium-wrappers-sumo' to the self-contained CJS build (the package's
// ESM build had a broken internal import in 0.7.x; the pin stays so the
// build that ships is the one that was verified); sumo is required because
// the recovery-code wrap runs Argon2id (crypto_pwhash) in the browser.
//
// NC1 v3 (XWING.md, 2026-10-09) needs libsodium-wrappers-sumo >= 0.8.4
// (libsodium 1.0.22): the vendored shared/envelope.js asserts
// `crypto_kem_xwing_*`. Verified on the pinned CJS sumo build under Node:
// crypto_kem_xwing_seed_keypair / enc / enc_deterministic / dec present,
// sizes 1216 / 32 / 1120 / 32, reports libsodium 1.0.22.

let sodiumPromise = null

export function getSodium() {
  if (!sodiumPromise) {
    sodiumPromise = (async () => {
      const mod = await import('libsodium-wrappers-sumo')
      const sodium = mod.default ?? mod
      await sodium.ready
      return sodium
    })()
  }
  return sodiumPromise
}
